import ko from 'knockout';

// Shortcut for setting a href
ko.bindingHandlers.href = {
    update(element, valueAccessor) {
        let href = ko.unwrap(valueAccessor());
        if (typeof href === 'function') {
            href = href();
        }
        element.setAttribute('href', href);
    },
};
